import { render, staticRenderFns } from "./AccordionWidget.vue?vue&type=template&id=1009c73e&scoped=true"
import script from "./AccordionWidget.vue?vue&type=script&lang=js"
export * from "./AccordionWidget.vue?vue&type=script&lang=js"
import style0 from "./AccordionWidget.vue?vue&type=style&index=0&id=1009c73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1009c73e",
  null
  
)

export default component.exports